import { useEffect, useState } from 'react';
import { API_URL, getSelectedProfileId } from '../utils';

export default function useCategoriesAndVideos() {
  const [categories, setCategories] = useState([]);
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [profileId, setProfileId] = useState(null);

  // Listen for profile changes
  useEffect(() => {
    const updateProfileId = () => {
      const currentProfileId = getSelectedProfileId();
      console.log('🔍 Profile ID check:', currentProfileId);
      setProfileId(currentProfileId);
    };

    // Initial check
    updateProfileId();

    // Listen for custom profile change event
    window.addEventListener('profileChanged', updateProfileId);

    return () => {
      window.removeEventListener('profileChanged', updateProfileId);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        // Step 1: Fetch categories
        // COMMENTED OUT - Not used yet
        // console.log('📂 Fetching categories...');
        // const categoriesResponse = await fetch(
        //     `${API_URL}/api/categories/?skip=0&limit=100`,
        //     {
        //         headers: {
        //             'accept': 'application/json',
        //         },
        //     }
        // );

        // if (!categoriesResponse.ok) {
        //     throw new Error('Failed to fetch categories');
        // }

        // const categoriesData = await categoriesResponse.json();
        // console.log('✅ Categories loaded:', categoriesData.length);
        // setCategories(categoriesData);

        // Step 2: Fetch videos with profile ID
        if (!profileId) {
          console.warn('⚠️ No profile selected, skipping videos fetch');
          setLoading(false);
          return;
        }

        console.log('🎬 Fetching videos for profile:', profileId);
        const videosResponse = await fetch(`${API_URL}/api/videos/?profile_id=${profileId}&skip=0&limit=100`, {
          headers: {
            accept: 'application/json',
          },
        });

        if (!videosResponse.ok) {
          throw new Error('Failed to fetch videos');
        }

        const videosData = await videosResponse.json();
        console.log('✅ Videos loaded:', videosData.length);
        setVideos(videosData);
      } catch (err) {
        console.error('❌ Error fetching data:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [profileId]); // Refetch when profileId changes

  return { categories, videos, loading, error };
}
